import { AlertService } from 'app/services/alert.service';
import { MessagesTitles } from 'app/models/messages';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, /*LOCALE_ID*/ } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';

import { AppComponent } from './app.component';
import { AmazingTimePickerModule } from "amazing-time-picker";
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { LoginComponent } from './login/login.component';
import { CambiarAccesoComponent } from './cambiar-acceso/cambiar-acceso.component';
import { RecuperarCuentaComponent } from './recuperar-cuenta/recuperar-cuenta.component';
import { Error404Component } from './error404/error404.component';

import { MatPaginatorModule } from '@angular/material/paginator';
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatNativeDateModule } from '@angular/material/core';

import { MatSortModule, MatTableModule } from '@angular/material';
import { ConfigComponent } from './configuracion/config/config.component';
import { SubComponentsModule } from './configuracion/components/subcomponents.module';
import { ConfigLayoutModule } from './configuracion/config/config-layout.module';


import { AdminLayoutModule } from './layouts/admin-layout/admin-layout.module';
import { SharedModule } from './shared/shared.module';

// libreria para tiempo de inactividad
import { BnNgIdleService } from 'bn-ng-idle';

// libreria para cerrar la session luego de un tiempo determinado
import { UserIdleModule } from 'angular-user-idle';

// SessionExpirationAlert
import { SessionExpirationAlert, SessionInteruptService } from 'session-expiration-alert';
import { AppSessionInteruptService } from './services/session.service';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



import { NgxMaskModule } from 'ngx-mask';



import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CargaMasivaComponent } from './negociables/factura/carga-masiva/carga-masiva.component';





// IMPORTO LOCALE DE PERÙ PARA FORMATEO DE FECHA
// COMENTADO PORQUE CAMBIA EL IDIOMA DE MANERA GLOBAL, NO POR COMPONENTE COMO SE ESPERABA



@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ComponentsModule,
    RouterModule,
    AppRoutingModule,
    MatPaginatorModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatSortModule,
    MatTableModule,
    MatIconModule,
    SubComponentsModule,
    ConfigLayoutModule,
    AmazingTimePickerModule,
    AdminLayoutModule,
    SharedModule,
    UserIdleModule.forRoot({ idle: 3, timeout: 5, ping: 3 }),
    SessionExpirationAlert.forRoot({ totalMinutes: 0.5 }),
    NgbModule,

    // TextMaskModule,
    NgxMaskModule.forRoot(),
    MatButtonModule
  ],
  exports: [
    MatIconModule,
    MatButtonModule
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    LoginComponent,
    RecuperarCuentaComponent,
    Error404Component,
    ConfigComponent,
    CambiarAccesoComponent,
  ],
  providers: [BnNgIdleService, {
    provide: SessionInteruptService,
    useClass: AppSessionInteruptService
  }, MessagesTitles, MessagesTitles, AlertService
    /*{provide: LOCALE_ID, useValue: 'en'},
    {provide: LOCALE_ID, useValue: 'es-PE'}
    jack*/
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
